import { useState } from 'react'

const DEFAULT_FILTERS = {
  dateFilter: 'all',
  fuelTypeFilter: 'all',
  selectedOrg: 'all',
  selectedBranch: 'all',
  customRange: { start: '', end: '' },
}

export function useFilters() {
  const [filters, setFilters] = useState(DEFAULT_FILTERS)

  function setDateFilter(value) {
    setFilters((prev) => ({ ...prev, dateFilter: value }))
  }

  function setFuelTypeFilter(value) {
    setFilters((prev) => ({ ...prev, fuelTypeFilter: value }))
  }

  function setSelectedOrg(value) {
    // Reset branch when org changes
    setFilters((prev) => ({ ...prev, selectedOrg: value, selectedBranch: 'all' }))
  }

  function setSelectedBranch(value) {
    setFilters((prev) => ({ ...prev, selectedBranch: value }))
  }

  function setCustomRange(range) {
    const { start, end } = range
    const corrected = start && end && end < start ? { start: end, end: start } : range
    setFilters((prev) => ({ ...prev, customRange: corrected }))
  }

  function resetFilters() {
    setFilters(DEFAULT_FILTERS)
  }

  return {
    filters,
    setDateFilter,
    setFuelTypeFilter,
    setSelectedOrg,
    setSelectedBranch,
    setCustomRange,
    resetFilters,
  }
}
